import { SxProps } from '@mui/material';
import { InputAdornment } from '@mui/material';
import { WarningCircle } from '@phosphor-icons/react/dist/ssr/WarningCircle';
import React from 'react';

export const ErrorAdornment = ({sx}: {sx?: SxProps}) => (
  <InputAdornment sx={sx}
                  disablePointerEvents
                  position="end">
    <WarningCircle size={24} color="#F14E42" weight="fill" />
  </InputAdornment>
);
